import HomePageImgQuickLink from "./pages/HomePageImgQuickLink";
import HomePageNewsAndEvents from "./pages/HomePageNewsAndEvents";

export default function LayoutHomePage() {
  return (
    <div className="LayoutHomePage">
      <HomePageImgQuickLink />
      <HomePageNewsAndEvents />
    </div>
  );
}
